import React from "react";
import "./Console.css";

const Console = () => {
	return (
		<div className="Console">
			<div className="__crt" />
			<div className="__line" />
		</div>
	);
};

export default Console;
